/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable complexity */
import attachValidation from '../../utils/form-validation';
import SelectorEngine from '../../utils/dom/selector-engine';
import { getDataFromForm } from '../../utils/misc';
import Request from '../../utils/request';
import DBSVenueFinder from '../../components/DBSVenueFinder';
import { extraDbsVenueData } from '../../components/FormGenerator/data';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';

class DbsCheckForm {
	constructor() {
		this.state = {
			role: '',
			isPaid: '',
			accredited: '',
			frequently: '',
			supervised: '',
			finalRole: '',
			digitalIdentity: '',
			availability: ''
		};
		this._wrapper = SelectorEngine.findOne('.p-dbs-check');
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	init() {
		this._form = SelectorEngine.findOne('.p-dbs-check__form', this._wrapper);
		this._isPaid = SelectorEngine.findOne('.p-dbs-check__form-paid', this._form);
		this._isAccredited = SelectorEngine.findOne('.p-dbs-check__form-accredited', this._form);
		this._howFrequently = SelectorEngine.findOne('.p-dbs-check__form-frequently', this._form);
		this._isSupervised = SelectorEngine.findOne('.p-dbs-check__form-supervised', this._form);
		this._venueSearch = SelectorEngine.findOne('.p-dbs-check__form-venue-search', this._form);
		this._errorWrapper = SelectorEngine.findOne('.p-dbs-check__error', this._wrapper);
		const errorDismissCta = SelectorEngine.findOne('.p-dbs-check__error-btn', this._errorWrapper);
		this._successWrapper = SelectorEngine.findOne('.p-dbs-check-success', this._wrapper);
		this._contentWrapper = SelectorEngine.findOne('.p-dbs-check__content', this._wrapper);
		this._valWrapper = SelectorEngine.findOne('.p-dbs-check__val-venue', this._wrapper);
		const valueWrapperCta = SelectorEngine.findOne('.p-dbs-check__val-venue-btn', this._valWrapper);
		this._roleWrapper = SelectorEngine.findOne('.p-dbs-check-success-role', this._successWrapper);
		this._verificationForm = SelectorEngine.findOne('.p-dbs-check__form-verification-form-id', this._form);
		this.availabilityFormWrapper = SelectorEngine.findOne('.p-dbs-check__form-availability-form', this._form);
		this.availabilityWrapper = SelectorEngine.findOne('.p-dbs-check__form-availability', this._form);
		this._errorMesaage = SelectorEngine.findOne('.lta-snackbar__label', this._errorWrapper);

		errorDismissCta.addEventListener('click', () => {
			this._errorWrapper.classList.add('u-hidden');
			location.reload();
		});

		valueWrapperCta.addEventListener('click', () => {
			this._valWrapper.classList.add('u-hidden');
		});

		// venue search is build as a seperate component DBSVenue Finder
		const dbsVenueFinder = new DBSVenueFinder(this._venueSearch, {
			data: {
				...extraDbsVenueData
			}
		});

		dbsVenueFinder.onChange((event, previousValue) => {
			if(typeof event?.value?.organisationName === 'string') {
				const isFreeTennisPark = event.value?.organisationName?.trim() === "Free Park Tennis";
				this.setTennisParkOptions(isFreeTennisPark);
			} else if(previousValue?.value?.organisationName?.trim() === 'Free Park Tennis') {
				this.setTennisParkOptions(false);
			}
		});

		this._form.addEventListener('change', () => {
			this._openHiddenSection();
		});

		this.fv = attachValidation(this._form, {
			'lta-search-input-field-name-dbs-venue': {
				validators: {
					notEmpty: {
						message: 'Please select a venue'
					}
				}
			},
			'first_name': {
				validators: {
					notEmpty: {
						message: 'Please enter a first name'
					},
					stringLength: {
						min: 2,
						message: 'First Name must be 2 or more characters'
					},
					regexp: {
						regexp: /^[a-zA-Z-' ]+$/,
						message: 'Please enter a firstname that contains only characters'
					}
				}
			},
			'last_name': {
				validators: {
					notEmpty: {
						message: 'Please enter a last name'
					},
					stringLength: {
						min: 2,
						message: 'Last Name must be 2 or more characters'
					},
					regexp: {
						regexp: /^[a-zA-Z-' ]+$/,
						message: 'Please enter lastname that contains only characters'
					}
				}
			},
			'email': {
				validators: {
					notEmpty: {
						message: 'Please enter an email address'
					},
					regexp: {
						regexp: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
						message: 'Please enter a valid email address'
					}
				}
			},
			'role': {
				// validated conditionally
				validators: {
					notEmpty: {
						message: 'Please select Role'
					}
				}
			},
			'paid': {
				// validated conditionally
				validators: {
					notEmpty: {
						message: 'Please select'
					}
				}
			},
			'accredited': {
				// validated conditionally
				validators: {
					notEmpty: {
						message: 'Please select'
					}
				}
			},
			'frequently': {
				// validated conditionally
				validators: {
					notEmpty: {
						message: 'Please select'
					}
				}
			},
			'supervised': {
				// validated conditionally
				validators: {
					notEmpty: {
						message: 'Please select'
					}
				}
			},
			'digitalId': {
				validators: {
					notEmpty: {
						message: 'Please select'
					}
				}
			},
			//validated conditionally
			'verificationId': {
				validators: {
					notEmpty: {
						message: 'Please select'
					}
				}
			},
			'availability': {
				validators: {
					notEmpty: {
						message: 'Please select'
					}
				}
			}
		});

		this.fv.on('core.form.valid', () => {
			this.submitEnquiry(this._form);
		});

		this.disableFormValidations();
	}

	setTennisParkOptions(isFreeTennisPark) {
		const roleWrapper = SelectorEngine.findOne('.p-dbs-check__form-role', this._form);
		const roles = SelectorEngine.find('input[name="role"]', roleWrapper);
		const beingPaid = SelectorEngine.findOne('.p-dbs-check__form-paid', this._form);
		const beingPaidOptions = SelectorEngine.find('input[name="paid"]', beingPaid);

		if(isFreeTennisPark) {
			this.checkOneAndDisableOthers(roles, 'tennis activator');
			setTimeout(() => {
				this.checkOneAndDisableOthers(beingPaidOptions, 'false');
			});
		} else {
			roles.forEach(option => {
				option.disabled = false;
				option.checked = false;
			});
			beingPaidOptions.forEach(option => {
				option.disabled = false;
				option.checked = false;
			});
		}
	}

	checkOneAndDisableOthers(elements, value) {
		elements.forEach(element => {
			if(element.value.trim().toLowerCase() !== value) {
				element.disabled = true;
			} else {
				element?.click();
			}
		});
	}

	disableFormValidations() {
		this.fv.disableValidator('accredited');
		this.fv.disableValidator('frequently');
		this.fv.disableValidator('supervised');
		this.fv.disableValidator('paid');
		this.fv.disableValidator('availability');
	}

	// Based on the ACC need to update the role. User Story 18390: Safeguarding (DBS): New values on DBS form on LTA website
	_openHiddenSection() {
		const roleValue = SelectorEngine.findOne('input[name = "role"]:checked', this._wrapper)?.value;
		const isPaidValue = SelectorEngine.findOne('input[name = "paid"]:checked', this._wrapper)?.value;
		const frequently = SelectorEngine.findOne('input[name = "frequently"]:checked', this._wrapper)?.value;
		const accredited = SelectorEngine.findOne('input[name = "accredited"]:checked', this._wrapper)?.value;
		const supervised = SelectorEngine.findOne('input[name = "supervised"]:checked', this._wrapper)?.value;
		const digitalId = SelectorEngine.findOne('input[name = "digitalId"]:checked', this._wrapper)?.value; //uncomment when 23932 is required
		const availability = SelectorEngine.findOne('input[name = "availability"]:checked', this._wrapper)?.value;

		if (availability === 'True') {
			this.availabilityFormWrapper.classList.remove('u-hidden');
		} else {
			this.availabilityFormWrapper.classList.add('u-hidden');
		}

		if (digitalId === 'True') {
			this._verificationForm.classList.remove('u-hidden');
			this.fv.enableValidator('verificationId');
		} else {
			this._verificationForm.classList.add('u-hidden');
			this.fv.disableValidator('verificationId');
		}

		if (roleValue != 'Others' && roleValue) {
			this.state.role = roleValue;
			this.fv.enableValidator('paid');
			this._isPaid.classList.remove('u-hidden');
			this._howFrequently.classList.add('u-hidden');
			this._isSupervised.classList.add('u-hidden');
			this._isAccredited.classList.add('u-hidden');
			if (isPaidValue == 'False' && roleValue == 'coaching') {
				this.state.isPaid = 'False';
				this.fv.disableValidator('paid');
				this._isAccredited.classList.remove('u-hidden');
				this.fv.enableValidator('accredited');
				this.state.accredited = accredited;
			} else {
				this.state.isPaid = isPaidValue;
				this._isAccredited.classList.add('u-hidden');
				this.fv.disableValidator('accredited');
			}
			this.state.accredited = accredited;
		} else if (roleValue) {
			this.fv.enableValidator('frequently');
			this.state.role = 'Others';
			this.state.isPaid = '';
			this._isPaid.classList.add('u-hidden');
			this._isAccredited.classList.add('u-hidden');
			this._howFrequently.classList.remove('u-hidden');
			if (frequently == 'Regularly') {
				this.state.frequently = 'Regularly';
				this._isSupervised.classList.add('u-hidden');
				this._isPaid.classList.remove('u-hidden');
				this.state.isPaid = isPaidValue;
			} else if ((frequently == 'VeryRegularly' && supervised == 'True') || supervised == 'False') {
				this.fv.enableValidator('supervised');
				this._isPaid.classList.remove('u-hidden');
				this.state.isPaid = isPaidValue;
			} else if (frequently == 'VeryRegularly') {
				this.fv.enableValidator('supervised');
				this.state.frequently = 'verRegularly';
				this._isSupervised.classList.remove('u-hidden');
				this._isPaid.classList.add('u-hidden');
			}
			this.state.supervised = supervised;
		}
		if (this.state.role && this.state.isPaid) {
			this.updateRole();
		}
	}

	// Based on the selected options finalizing the role of the user.
	updateRole() {
		if (this.state.role == 'coaching' && this.state.isPaid == 'True') {
			this.state.finalRole = 'Coaching Professional - RA';
		} else if (this.state.role == 'coaching' && this.state.isPaid == 'False' && this.state.accredited == 'True') {
			this.state.finalRole = 'Coaching Professional - RA';
		} else if (this.state.role == 'coaching' && this.state.isPaid == 'False' && this.state.accredited == 'False') {
			this.state.finalRole = 'Vol Coaching Professional - RA';
		} else if (this.state.role == 'officiating' && this.state.isPaid == 'True') {
			this.state.finalRole = 'Officiating Professional - RA';
		} else if (this.state.role == 'officiating' && this.state.isPaid == 'False') {
			this.state.finalRole = 'VolOfficiating Professional-RA';
		} else if (this.state.role == 'Tennis Activator' && this.state.isPaid == 'True') {
			this.state.finalRole = 'Tennis Activator - RA';
		} else if (this.state.role == 'Tennis Activator' && this.state.isPaid == 'False') {
			this.state.finalRole = 'Vol Tennis Activator - RA';
		} else if (this.state.role == 'Tennis Leader' && this.state.isPaid == 'True') {
			this.state.finalRole = 'Tennis Leader - RA';
		} else if (this.state.role == 'Tennis Leader' && this.state.isPaid == 'False') {
			this.state.finalRole = 'Vol Tennis Leader - RA';
		} else if (this.state.role == 'Providing medical care' && this.state.isPaid == 'True') {
			this.state.finalRole = 'Medical Professional - RA';
		} else if (this.state.role == 'Providing medical care' && this.state.isPaid == 'False') {
			this.state.finalRole = 'Vol Medical Professional - RA';
		} else if (this.state.role == 'Welfare Officer' && this.state.isPaid == 'True') {
			this.state.finalRole = 'Welfare Officer - RA';
		} else if (this.state.role == 'Welfare Officer' && this.state.isPaid == 'False') {
			this.state.finalRole = 'Vol Welfare Officer - RA';
		} else if (this.state.role == 'Others' && this.state.frequently == 'Regularly' && this.state.isPaid == 'True') {
			this.state.finalRole = 'Supervisor - NonRA';
		} else if (this.state.role == 'Others' && this.state.frequently == 'Regularly' && this.state.isPaid == 'False') {
			this.state.finalRole = 'Vol Supervisor - NonRA';
		} else if (this.state.role == 'Others' && this.state.supervised == 'True' && this.state.isPaid == 'True') {
			this.state.finalRole = 'Supervisor - NonRA';
		} else if (this.state.role == 'Others' && this.state.supervised == 'True' && this.state.isPaid == 'False') {
			this.state.finalRole = 'Vol Supervisor - NonRA';
		} else if (this.state.role == 'Others' && this.state.supervised == 'False' && this.state.isPaid == 'True') {
			this.state.finalRole = 'Supervisor - RA';
		} else if (this.state.role == 'Others' && this.state.supervised == 'False' && this.state.isPaid == 'False') {
			this.state.finalRole = 'Vol Supervisor - RA';
		}

		// If the slected one amoung the below then we show another question to the user. Spike 18681: Safeguarding (DBS): New question on data capture form
		if (
			this.state.finalRole === 'Coaching Professional - RA' ||
			this.state.finalRole === 'Officiating Professional - RA' ||
			this.state.finalRole === 'VolOfficiating Professional-RA' ||
			this.state.finalRole === 'Welfare Officer - RA' ||
			this.state.finalRole === 'Vol Welfare Officer - RA'
		) {
			const availability = SelectorEngine.findOne('input[name = "availability"]:checked', this._wrapper)?.value;
			this.state.availability = availability;
			this.availabilityWrapper.classList.remove('u-hidden');
			this.fv.enableValidator('availability');
		} else {
			this.availabilityWrapper.classList.add('u-hidden');
			this.state.availability = '';
		}
	}

	async submitEnquiry(form) {
		startLoadingAnimation(true);

		const dataObject = getDataFromForm(form);
		const shortCodeWrapper = SelectorEngine.findOne('.lta-autosuggest-input-result_venue-number');
		const orgNameWrapper = SelectorEngine.findOne('.lta-autosuggest-input-result_venue-name');
		const shortCode = shortCodeWrapper?.innerText;
		const orgName = orgNameWrapper?.innerText;

		if (orgName === undefined || shortCode === undefined) {
			this._valWrapper.classList.remove('u-hidden');
			this._valWrapper.scrollIntoView();
			return;
		}

		this.state.digitalIdentity =
			dataObject.digitalId === 'True' && dataObject.verificationId === 'True' ? 'True' : 'False';

		const finalData = {
			firstName: dataObject.first_name,
			lastName: dataObject.last_name,
			email: dataObject.email,
			role: this.state.finalRole,
			organisationShortcode: shortCode,
			organisationName: orgName,
			digitalIdentity: this.state.digitalIdentity,
			availability: this.state.availability
		};

		const url = '/api/dbs/submit';

		await Request.post(url, finalData).catch((error) => {
			if (error?.error?.errorCode == '00') {
				stopLoadingAnimation();
				this._roleWrapper.textContent = finalData.role;
				this._contentWrapper.classList.add('u-hidden');
				this._successWrapper.classList.remove('u-hidden');
				this._successWrapper.scrollIntoView();
			} else {
				stopLoadingAnimation();
				this._errorMesaage.textContent = error?.error?.errorMessage;
				this._errorWrapper.classList.remove('u-hidden');
				this._errorWrapper.scrollIntoView();
				console.log('Error :', error);
			}
		});
	}
}

const DBSCheckForm = new DbsCheckForm();
export default DBSCheckForm;
